import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizeService } from './authorize.service';
import { tap, map } from 'rxjs/operators';
import { ApplicationPaths, QueryParameterNames } from './api-authorization.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard implements CanActivate {
  constructor(private authorize: AuthorizeService, private router: Router) {
  }
  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this.authorize.isAuthenticated()
        .pipe(tap(isAuthenticated => this.handleAuthorization(isAuthenticated, _next, state)));
  }

  private handleAuthorization(isAuthenticated: boolean, _next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (isAuthenticated) {
      const currentUser = this.authorize.getUser();
      if (currentUser) {
        let roles = _next.data['permittedRoles'] as Array<string>;

        // check if route is restricted by role
        if (roles && currentUser.pipe(map(u => u && u.role))) {
          for (var i = 0; i < roles.length; i++) {
            // user roles should contain all roles, otherwise not authorized
            if (!currentUser.pipe(map(u => u.role.includes(roles[i])))) {
              // role not authorised
              this.router.navigate(['/' + ApplicationPaths.AccessDenied]);
            }
          }
        }
      }
    }
    else {
      var returnUrl = state.url;
      if (returnUrl === '/') {
        // this is necessary otherwise the app gets redirect to "nothing" and breaks
        returnUrl = undefined;
      }

      this.router.navigate(ApplicationPaths.LoginPathComponents, {
        queryParams: {
          [QueryParameterNames.ReturnUrl]: returnUrl
        }
      });
    }
  }
}
